export default [
  {
    id: 'cb648ba6-fdfc-4d90-8ed5-e8251b18e9e0',
    path: 'data-model',
    name: 'data-model',
    meta: { title: '数据模型' },
    children: [
      {
        id: '1024fc07-021c-4631-8a67-19c9eca7e348',
        path: 'model-development',
        name: 'model-development',
        component: () => {
          return import('../views/data-model/ModelDevelopment')
        },
        meta: {
          title: '模型开发',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            copy: {
              id: 3,
              name: 'copy',
              desc: '复制',
              access: true,
            },
            preview: {
              id: 4,
              name: 'preview',
              desc: '数据预览',
              access: true,
            },
          },
        },
      },
      {
        id: 'de1d2a38-7d04-4289-9345-4e95086da416',
        path: 'add-model',
        name: 'add-model',
        component: () => {
          return import('../views/data-model/AddModel')
        },
        meta: {
          title: '新增模型',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-model/model-development',
        },
      },
      {
        id: 'f103bcf4-849f-42cf-91e7-981e6d8c7cb3',
        path: 'data-preview',
        name: 'data-preview',
        component: () => {
          return import('../views/data-model/DataPreview')
        },
        meta: {
          title: '数据预览',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-model/model-development',
        },
      },
    ],
  },
]
